// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Xo","link":"e_Yo","imageContainer":"e_Zo","author":"e__o","text":"e_0o","buttonIcon":"e_1o"};